import React from 'react'
import LayoutNew from '../components/shared/LayoutNew'

export default function ReferNew() {
    return (
        <LayoutNew>
            <div div className='style09'style={{marginTop:'55px'}}>
                <div className="container main-wrap referral-page">
                    <div className="header header-refer">
                        <img
                            src="/assets/images/referimg.png"
                            alt="Referral Program"
                            className="header-gif"
                        />
                        <h1>Referral Bonus</h1>
                    </div>
                    <div className="content">
                        <p>
                            The BEST referral program is here! Earn <strong>10% commission</strong>{" "}
                            every time your referred friend experiences a loss. This commission will
                            be directly added to your main balance on the 1st of every month, ensuring
                            consistent rewards.{" "}
                        </p>
                        <div className="code-container">
                            <span className="referral-code">diamond</span>
                            <div className="tooltip-container">
                                <button className="copy-btn">Copy</button>
                            </div>
                        </div>
                        <p>
                            সেরা রেফারেল প্রোগ্রাম এখানে! আপনার রেফার করা বন্ধু প্রতিবার ক্ষতি করলে
                            আপনি 10% কমিশন উপার্জন করবেন। এই কমিশন প্রতি মাসের ১ তারিখে আপনার মূল
                            ব্যালেন্সে যোগ করা হবে, জা আপনার রেফারেল থেকে নিয়মিত পুরস্কার নিশ্চিত
                            করবে!{" "}
                        </p>
                        <div className="stat">
                            <div className="stat-value">
                                Ongoing pnl:<span className="text-red">0</span>
                            </div>
                            <div className="stat-value">
                                Ongoing commission: <span>0</span>
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="inner-wrapper">
                                <form className="bet_status">
                                    <div className="row">
                                        <div className="col-xl-12 col-md-12">
                                            <div className="refer-filter row">
                                                <div className="mb-lg-0 mb-3 flex-grow-0 pe-3  col-lg-3 col-sm-6">
                                                    <div className="bet-sec bet-period">
                                                        <label className="px-2 form-label">From</label>
                                                        <div className="form-group">
                                                            <input
                                                                max="2026-02-12"
                                                                type="date"
                                                                className="small_form_control form-control"
                                                                defaultValue="2026-02-01"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mb-lg-0 mb-3 flex-grow-0 ps-3 col-lg-3 col-sm-6">
                                                    <div className="bet-sec bet-period">
                                                        <label className="px-2 form-label">To</label>
                                                        <div className="form-group">
                                                            <input
                                                                min="2026-02-01"
                                                                max="2026-02-12"
                                                                type="date"
                                                                className="small_form_control form-control"
                                                                defaultValue="2026-02-12"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="history-btn mt-2">
                                        <ul className="list-unstyled mb-0">
                                            <li>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{lineHeight:'2.6'}}
                                                    className="theme_dark_btn btn btn-primary"
                                                >
                                                    Search
                                                </button>
                                            </li>
                                            <li>
                                                <button
                                                    type="button"
                                                    disabled
                                                    style={{lineHeight:'2.6'}}
                                                    className="me-0 theme_light_btn btn btn-primary"
                                                >
                                                    Reset
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div className="table-container">
                            <div className="tab-content">
                                <div className="table-container ng-star-inserted">
                                    <table className="referral-table">
                                        <thead>
                                            <tr>
                                                <th>Referral Username</th>
                                                <th>P&amp;L</th>
                                                <th>Bonus Earned</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>user1</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <td>platinum</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <td>bronze</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <td>silver</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                            <tr>
                                                <td>siam0030</td>
                                                <td>0</td>
                                                <td>0</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </LayoutNew>
    )
}
